import React, { useCallback, useRef } from 'react'
import style from './style.module.scss'
import { Header, Text } from '@crossfit/design-system'
import Image from './Image.svg'
import Camera from './Camera.svg'
import { useAffiliate } from 'hooks/useAffiliate'
import { useAuth } from 'components/Auth'

export type SelectModalProps = {
  onClose: () => void
  onSelect: (FileList) => void
}

export default function SelectionModal({
  onClose,
  onSelect,
}: SelectModalProps) {
  const MAX_SIZE = import.meta.env.VITE_MAX_IMAGE_SIZE || 5000000 //5MB
  const galleryRef = useRef(null)

  return (
    <div className={style.modalBackdrop} onClick={onClose}>
      <div className='modal-bottom'>
        <div className={style.modalContent}>
          <Header size='sm' as='h1' className={style.modalHeader}>
            UPLOAD
          </Header>
          <div className={style.modalSelectionOptions}>
            <div
              className={style.modalSelectionOption}
              onClick={(e) => {
                galleryRef.current.click()
                e.stopPropagation()
              }}
            >
              <input
                id='fileUpload'
                name='fileUpload'
                style={{ display: 'none' }}
                type='file'
                accept='image/*'
                onChange={(e) => onSelect(e.target.files)}
                ref={galleryRef}
              />
              <img src={Image} className={style.imageIcon} />
              <Text type='button' size='sm'>
                VIEW PHOTO LIBRARY
              </Text>
            </div>
            <div className={style.modalSelectionOption}>
              <img src={Camera} className={style.imageIcon} />
              <Text type='button' size='sm'>
                TAKE A PHOTO
              </Text>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
